import me from "../profile.jpg"
import './intro.css';
import Myresume from "../Resume/resume";
import { useState } from "react";
const Intro = () => {
  const [isOpen, setIsOpen] = useState(false);
  const togglePopup = () => {
    setIsOpen(!isOpen);
  }
  return (
    <>
    <div className="i" id = "home">
      <div className="i-left">
        <div className="i-leftWrapper">
          <h2 className="i-intro"></h2>
          <h1 className="i-name"> Anirudh Thakur</h1>
          <div className="i-title">
            <div className="i-title-wrapper">
              <div className="i-title-item">Software Engineer</div>
              <div className="i-title-item">Web Developer</div>
              <div className="i-title-item">Machine Learning Enthusiast</div>
              <div className="i-title-item">Blogger</div>
          </div>
          </div>
          <div className="i-description">
              Hands-on, successful Software/Web Engineer with verifiable success leading teams in delivering appropriate technology solutions for web products.
              Currently pursuing my masters from University of Texas Dallas in Computer Science.
              <br></br>
              <button className="i-resume-popup" onClick={togglePopup}>Resume</button>

              {isOpen && <Myresume
                content={<>
                <b></b>
              </>}
              handleClose={togglePopup}
                />}
          </div>
        </div>
      </div>
      <div className="i-right">
        <div className="i-bg">
          <div className="i-img">
              <img src={me} alt="profile image not loaded" width = "100%" height = "600" />
              </div>
          
        </div>
      </div>
      </div>
      </>
  )
}

export default Intro